// Generated by CoffeeScript 2.7.0
var Admin__YetAnotherWorkflow__SettingsController;

import SettingsPanel from '../concerns/settings_panel.js';

import FlowMoreOperations from './concerns/flow_more_operations.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import SerialNumber from 'trunks/vue/admin/compositions/yet_another_workflow/serial_number.js';

export default Admin__YetAnotherWorkflow__SettingsController = (function() {
  class Admin__YetAnotherWorkflow__SettingsController extends Skylark.App.BaseController {
    constructor() {
      super();
      this.gid = new Skylark.Libs.GlobalID(this.getVars('gid'));
      this.__toggleNavMenu();
    }

    base() {
      this._initDropdownSelect(this.__dropdownSelectFunc.bind(this));
      this._initDisplayFieldsSetting();
      return this._bindInputEvent();
    }

    after_commit() {
      var _toggleDropdownSelectView, dropdown_url_el, flow;
      flow = DomMaster.find('.edit_yet_another_workflow_flow');
      dropdown_url_el = flow.find('.js-dropdown-url');
      _toggleDropdownSelectView = function(judge) {
        switch (judge) {
          case 'redirect':
            return dropdown_url_el.show();
          default:
            return dropdown_url_el.hide();
        }
      };
      _toggleDropdownSelectView(flow.find('input[name="flow[after_submit_action]"]').node.value);
      return this._initDropdownSelect(_toggleDropdownSelectView);
    }

    beforeVisit(event, action) {
      if (action === 'base' && this._settingChanged) {
        event.preventDefault();
        return newConfirm({
          title: '您有更改未保存， 确定要离开吗',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).$on('ensureClicked', function() {
          return location.href = event.data.url;
        });
      }
    }

    resetChangedStatus() {
      return this._settingChanged = false;
    }

    serial_number_fields() {
      var date_time_fields, el, enable_custom_sn, form, gid, radio_button_fields, serial_number_fields, vm;
      ({gid, radio_button_fields, enable_custom_sn, serial_number_fields, date_time_fields} = this.getVars());
      form = new Skylark.App.Model.Form({});
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('serial-number-fields-content');
      return vm = new SerialNumber({
        el: el,
        data: {
          form: form,
          fields: serial_number_fields,
          enabledCustomSerialNumber: enable_custom_sn,
          gid: new Skylark.Libs.GlobalID(gid)
        },
        propsData: {
          formFields: radio_button_fields.concat(date_time_fields)
        }
      });
    }

    _initDropdownSelect(toggleViewFun) {
      return _.each(DomMaster.findAll('.dropdown-select'), function(select_el) {
        var dropdown_input;
        dropdown_input = select_el.find('.js-dropdown-input');
        return new Skylark.Elements.DropdownSelect(select_el, function(active_option_item) {
          dropdown_input.node.value = active_option_item.node.data('value');
          return typeof toggleViewFun === "function" ? toggleViewFun(active_option_item.node.data('value')) : void 0;
        });
      });
    }

    _initDisplayFieldsSetting() {
      var fields, init_values, readonly, value_input;
      fields = $currentController.getVars('candidate_marked_fields');
      value_input = DomMaster.find('.js-display-fields-value');
      readonly = value_input.node.hasAttribute('readonly');
      init_values = value_input.node.getAttribute('value').split(',');
      fields = this.__groupFields(fields, init_values);
      return new FilterOptions({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('display_fields_setting_container'),
        propsData: {
          groupedOptions: fields,
          multiple: true,
          disabled: readonly,
          maxSelectedOptionsLength: 4
        }
      }).$on('valueChanged', (vm) => {
        this._settingChanged = true;
        return value_input.node.setAttribute('value', _.pluck(vm.selectedOptions, 'id'));
      }).$on('valueError', function() {
        return newAlertify('最多显示4个字段', {
          type: 'error'
        });
      });
    }

    _bindInputEvent() {
      return document.body.proxy('input', '.js-text-input', _.debounce(() => {
        return this._settingChanged = true;
      }, 500));
    }

    _doRepairFlow() {}

    __dropdownSelectFunc() {
      return this._settingChanged = true;
    }

    __groupFields(fields = [], init_values) {
      return _.map(fields, function(field) {
        if (field.children) {
          return {
            name: field.title,
            options: _.map(field.children, function(child) {
              return {
                id: child.id,
                name: child.title,
                _selected: _.includes(init_values, String(child.id))
              };
            })
          };
        } else {
          return {
            options: [
              {
                id: field.id,
                name: field.title,
                _selected: _.includes(init_values,
              String(field.id))
              }
            ]
          };
        }
      });
    }

  };

  Admin__YetAnotherWorkflow__SettingsController.include(SettingsPanel, FlowMoreOperations, ToggleNavMenuAction);

  return Admin__YetAnotherWorkflow__SettingsController;

}).call(this);
